import z from "zod";

export const rnmRequestShowPageSearchSchema = z.object({
  tab: z
    .enum(["details", "materialList", "attachments", "comments", "history"])
    .default("details")
    .catch("details"),
});
